export const API_BASE_URL ="https://dgbazaar.in/backend/api/"; //Live Api
export const IMAGE_URL ="https://dgbazaar.in/backend/public"; //Live
